// extracted by mini-css-extract-plugin
export var o_carrusel4 = "carrusel4-module--o_carrusel4--beeb2";
export var o_carrusel4__card = "carrusel4-module--o_carrusel4__card--4ca22";
export var o_carrusel4__cardContainer = "carrusel4-module--o_carrusel4__cardContainer--3a129";
export var o_carrusel4__container = "carrusel4-module--o_carrusel4__container--be188";
export var o_carrusel4__h3 = "carrusel4-module--o_carrusel4__h3--3e501";
export var o_carrusel4__img = "carrusel4-module--o_carrusel4__img--72e9d";
export var o_carrusel4__intro = "carrusel4-module--o_carrusel4__intro--cd694";
export var o_carrusel4__link = "carrusel4-module--o_carrusel4__link--1286c";
export var o_carrusel4__p = "carrusel4-module--o_carrusel4__p--47ea9";
export var o_carrusel4__slider = "carrusel4-module--o_carrusel4__slider--c7bb6";